import React from 'react';
import { Banner } from './CreateStyled';
import { Link } from 'react-router-dom';

const BannerContainer = ({ session }) =>
  (session.aic_token || session.formslive_token) && (
    <Form1Banner provider={getProviderName(session)} />
  );

const getProviderName = (session) => {
  switch (true) {
    case !!session.aic_token:
      return 'AICSA';
    case !!session.formslive_token:
      return 'Forms Live';
    default:
      return '';
  }
};

const Form1Banner = ({ provider }) => (
  <Banner>
    <div>
      <b>Note</b> The Form 1 document will be made available on your connected{' '}
      {provider} account.
    </div>
    <Link style={{ color: '#fff' }} to="/connections">
      View Connections
    </Link>
  </Banner>
);

export default BannerContainer;
